import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-incrementdetails-grid',
  templateUrl: './incrementdetails-grid.component.html',
  styleUrls: ['./incrementdetails-grid.component.css']
})
export class IncrementdetailsGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/serviceregister/incrementdetails/incrementdetails-grid/incrementdetails-grid.component.ts